// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__Afw9z","left":"StickyBox_left__MRCxQ","right":"StickyBox_right__2nbt8"};